module.exports = __webpack_public_path__ + "img/clue1_light.3186ebb6.png";